/** Leaf under the shell-owned Cockpit group (the tools/ prefix is URL-only). */
export const healthCheckNavItems = [
  {
    labelKey: 'healthChecks.nav.label',
    to: { name: 'HealthChecks' },
    navKey: 'healthChecks',
    // Literal-narrowed so app wiring verifies this inferred contribution against `NavItem`
    // without reversing the enforced app -> feature dependency direction for a type import.
    visibility: { control: 'permission' as const, id: ['configuration_control'] },
  },
]
